/** DevPath mark: a terminal prompt on a glowing circuit tile. */
export default function Logo({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 34 34" aria-hidden="true" className="shrink-0">
      <rect x="1" y="1" width="32" height="32" rx="9" fill="#111827" stroke="hsl(var(--primary))" strokeWidth="2" />
      <path
        d="M9 21 L14 16 L9 11 M18 23 L25 23"
        fill="none"
        stroke="hsl(var(--primary))"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
